import React, {useEffect, useState} from "react";
import dynamic from 'next/dynamic'
import {
    bigNumberFormat,
    getColor, getBahabinText,
    getTitleFaIranFinancialMarkets, getTodayJalaliDate,
    lastChangeRenderer
} from "../../../util/DominantUtil";
import Head from "next/head";
import {Helmet} from "react-helmet";

const BoxDynamicComponent = dynamic(() => import('../../../components/box/Box'))

const TableVirtualizedDynamicComponent = dynamic(() => import('../../../components/virtualized/virtualized'))
export default function Watchlist(response) {
    const [data, setData] = useState(null);
    const [rows, setRows] = useState(response.data);
    const [lastUpdate, setLastUpdate] = useState(response.lastUpdate);
    const [sectors] = useState([]);
    const [categoryName, setCategoryName] = useState('همه')
    const [tableBgColor, setTableBgColor] = useState('bg-white');
    const [autoScrollIntervalId, setAutoScrollIntervalId] = useState(null)
    const [scrollToIndex, setScrollToIndex] = useState(16);

    useEffect(() => {
        return () => {
            cleanUpAutoScrollIndex()
        }
    }, []);

    // useEffect(() => {
    //     if (rows && isStockMarketTime) handleSwitchAutoScroll(0)
    // }, [rows])

    // useEffect(() => {
    //     if (isStockMarketTime) {
    //         handleSwitchAutoScroll(0)
    //         handleSwitchDark(1)
    //
    //         const autoCallAPI = setInterval(() => {
    //             dispatch(actions.fetchWatchList());
    //         }, 5000);
    //
    //         return () => {
    //             clearInterval(autoCallAPI);
    //         }
    //     } else {
    //         cleanUpAutoScrollIndex()
    //         handleSwitchDark(0)
    //     }
    // }, [isStockMarketTime])

    useEffect(() => {
        if (!!rows && rows.length > 0) {
            if (sectors.length === 0) {
                sectors.push('همه');
                for (const index in rows) {
                    sectors.push(rows[index].name);
                }
            }

            if (!data) showAllRows();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows]);

    function cleanUpAutoScrollIndex() {
        clearInterval(autoScrollIntervalId);
        setScrollToIndex(0);
        setAutoScrollIntervalId(null);
    }

    function dropDownHandler(value) {
        setCategoryName(value)
        if (value === 'همه') showAllRows();
        else {
            const data = rows.filter((x) => x.name === value)[0].data
            // setData(Immutable.List(data))
            setData(data)
        }
    }

    function showAllRows() {
        // setData(Immutable.List(rows.flatMap(x => x.data)))
        setData(rows.flatMap(x => x.data))
    }

    function handleSwitchAutoScroll(value) {
        if (value && data && data.length > 20) {
            const id = setInterval(() => {
                setScrollToIndex(prevTime => (prevTime + 1) % data.length); // <-- Change this line!
            }, 1000);
            setAutoScrollIntervalId(id)
        }

        if (value === false) cleanUpAutoScrollIndex()
    }

    function updateIndex() {
        const counter = scrollToIndex + 1;
        const current = scrollToIndex < 10 ? 10 : scrollToIndex;
        const nData = (counter + current)
        setScrollToIndex(nData + 10)
    }


    function handleSwitchDark(value) {
        return setTableBgColor(value ? 'bg-dark' : 'bg-white')
    }

    const properties = {
        sectors: sectors,
        dropDownInputPlace: 'گروه',
        dropDownIconClassName: 'fa-industry',
        // checkedScroll: isStockMarketTime,
        checkedScroll: false,
        switchAutoScroll: true,
        enableAutoScrollButton: true,
        // enableAutoScrollBorder: isStockMarketTime && scrollToIndex !== 0,
        enableAutoScrollBorder: false,
        handleSwitchAutoScroll: handleSwitchAutoScroll,
        // checkedDark: isStockMarketTime,
        checkedDark: false,
        switchDarkBackground: true,
        handleSwitchDark: handleSwitchDark,
        dropDownHandler: dropDownHandler,
        lastUpdate: lastUpdate,
        help: {
            title: 'دیده بان بازار',
            content: `      امکانات:
            نمایش تابلو معاملات

            حجم به مبنا:
            حجم معاملات چند برابر حجم مبنا بوده است.
            `
        }
    };

    const tooltipSteps = [
        {
            target: '.extraDarkTheme',
            content: 'تغییر رنگ پس زمینه به سیاه',
            placement: 'right',
        },
        {
            target: '.extraAutoScroll',
            content: 'پیمایش صفحه به صورت خودکار',
            placement: 'right',
        },
        {
            target: '.extraDropDown',
            content: 'انتخاب گروه یا صنعت',
            placement: 'right',
        },
        {
            target: '.extra-last-update',
            content: 'زمان دقیق به روز رسانی',
            placement: 'right',
        },
    ]

    const description = `با استفاده از بهابین قیمت بازار بورس را مشاهده کنید`
    const title = `قیمت لحظه ای بورس`

    return (
        <BoxDynamicComponent uiActions={properties} title={categoryName} loaded={properties.lastUpdate && data}
                             showRW={true}
                             heading={`نرخ و نوسانات بازار بورس ${getTodayJalaliDate()}`}
                             linksMap={{
                                 'last': 'بازار بورس',
                             }}
                             leftBoxClassName={'w-100'}
                             height='930px'
                             tooltipSteps={tooltipSteps}>
            <Helmet
                title={'قیمت امروز خرید و فروش بازار بورس' + getBahabinText()}
                meta={[{name: 'description', content: description}, {
                    property: 'twitter:description',
                    content: description
                }, {property: 'og:title', content: title}]}
            />
            <TableVirtualizedDynamicComponent
                columns={sourceColumn}
                mutableData={data}
                defaultSortBy={'v'}
                defaultSortDirection={'DESC'}
                keyField="s"
                customHeight={890}
                numberFormat={true}
                scrollToIndex={scrollToIndex}
                setBgClassName={() => tableBgColor}
            />
        </BoxDynamicComponent>
    );
};

export async function getServerSideProps(context) {
//    const data = getWatchlistFakeData();
    const res = await fetch(`https://api.bahabin.com/watchlist/persian/bySector`)
    const apiData = await res.json()
    return {
        props: {
            data: apiData ? apiData.data : data,
            lastUpdate: apiData ? apiData.lastUpdate : 0
        }
    }
}

function getWatchlistFakeData() {
    const d = {
        "bv": 0,
        "cl": 0,
//                  "insCode": 0,
        "c": 0,
        "p": 0,
        "P": 0,
        "o": 0,
        "os": 0,
        "s": "-",
        "vl": 0,
        "v": 0,
        "vBv": 0
    }

    return Array.from({length: 20}, (_, k) => d);
}

const sourceColumn = [
    {
        title: "نماد",
        dataIndex: "s",
        type: 'link',
        sorter: true,
        enable: true,
    },
    {
        title: "آخرین",
        dataIndex: "c",
        sorter: true,
        enable: true,
    },
    {
        title: "تغییر آخرین",
        dataIndex: "P",
        renderer: lastChangeRenderer,
        colorRenderer: getColor,
        suffix: '%',
        sorter: true,
        enable: true,
    },
    {
        title: "پایانی",
        dataIndex: "cl",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "حجم",
        dataIndex: "v",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "ارزش",
        dataIndex: "vl",
        renderer: bigNumberFormat,
        sorter: true,
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "حجم به مبنا",
        dataIndex: "vBv",
        renderer: x => x.toFixed(2),
        sorter: true,
        enable: true,
        disableOnMobile: true,
    }
]